const state = {
  config: null,
  show: false,
  currentStep: 'firstStep',
  imgToShow: '',
  mainBinding: 'all',
  binding: '',
  galeryOpen: false,
  comicShow: false,
  audio: false,
  audioWait: false,
  autoMove: false,
  goTo: -1,
  clearSteps: [],
};

const mutations = {
  STATE_SET_CLEAR_STEPS(state, a) {
    state.clearSteps = a;
  },
  STATE_SET_GO_TO(state, a) {
    state.goTo = a;
  },
  STATE_SET_CURRENT_STEP(state, a) {
    state.currentStep = a;
  },
  STATE_SET_IMG_TO_SHOW(state, a) {
    state.imgToShow = a;
  },
  STATE_SET_GALERY_OPEN(state, a) {
    state.galeryOpen = a;
  },
  STATE_COMIC_SHOW(state, a) {
    state.comicShow = a;
  },
  STATE_AUDIO(state, a) {
    state.audio = a;
  },
  STATE_AUDIO_WAIT(state, a) {
    state.audioWait = a;
  },
  STATE_AUTO_MOVE(state, a) {
    state.autoMove = a;
  },
  STATE_PRESENTATION_SHOW(state, a) {
    state.show = a;
  },
  STATE_PRESENTATION_CONFIG(state, a) {
    state.config = a;
  },
  STATE_PRESENTATION_BINDING(state, a) {
    state.binding = a;
  },
  STATE_PRESENTATION_MAIN_BINDING(state, a) {
    state.mainBinding = a;
  },
};

const getters = {
  getPresentationClearSteps: (state) => {
    return state.clearSteps;
  },
  getPresentationGoTo: (state) => {
    return state.goTo;
  },
  getCurrentStep: (state) => {
    return state.currentStep;
  },
  getCurrentBind: (state) => {
    return state.binding;
  },
  getCurrentMainBind: (state) => {
    return state.mainBinding;
  },
  getPresentationState: (state) => {
    return state.show;
  },
  getPresentationConfig: (state) => {
    return state.config;
  },
  getImgToShow: (state) => {
    return state.imgToShow;
  },
  getGaleryOpen: (state) => {
    return state.galeryOpen;
  },
  getComicShow: (state) => {
    return state.comicShow;
  },
  getAudio: (state) => {
    return state.audio;
  },
  getAudioWait: (state) => {
    return state.audioWait;
  },
  getAutoMove: (state) => {
    return state.autoMove;
  },
};
export default {
  state,
  mutations,
  getters,
};
